import axios from 'axios';
import moment from 'moment-timezone';
import { useEffect, useMemo, useState } from 'react';
import { formatBalance } from '../../../helpers/NumberFormatter';
import { NextOrderInfo, NextOrderState } from '../../Overview/types';
import { Bot } from '../types';
import './index.css';

import ServicePaths from '../../../bridge/utils/ServicePaths';

interface Props {
  bot: Bot;
}

const Info: React.FC<Props> = (props: Props) => {
  const { bot } = props;

  const [nextOrderDate, setNextOrderDate] = useState<NextOrderInfo | undefined>(
    undefined,
  );

  useEffect(() => {
    const fetch = async () => {
      const { data } = await axios({
        url: ServicePaths.DATA.GetClientNextWakeUpInfo,
        method: 'POST',
        data: {
          botId: bot.botId,
        },
      });

      setNextOrderDate(data);
    };

    fetch();
  }, [bot.botId]);

  const stateText = useMemo(() => {
    switch (nextOrderDate?.state) {
      case NextOrderState.MultiOrder:
        return 'Multi Ordering';

      case NextOrderState.CbrRange:
        return 'Cbrt Range';

      case NextOrderState.OrderReady:
        return 'Waiting To Start Mrc State';

      case NextOrderState.PendingOrderChoice:
        return 'Waiting for cbr to get big enough';

      default:
        return '8. Not Ready To Order';
    }
  }, [nextOrderDate?.state]);

  return (
    <div className="detail-info-container">
      <span className="detail-info-title">Extra Info</span>
      <div className="detail-info-row">
        <span className="detail-info-label">Enabled:</span>
        <span className="detail-info-value">
          {bot.isEnabled ? 'Yes' : 'No'}
        </span>
      </div>

      {!!nextOrderDate && (
        <>
          <div className="detail-info-row">
            <span className="detail-info-subtitle">Next Wake Up:</span>
          </div>

          <div className="detail-info-row">
            <span className="detail-info-value">{stateText}</span>
          </div>
          <div className="detail-info-row">
            <span className="detail-info-label">Date:</span>
            <span className="detail-info-value">
              {moment(nextOrderDate.nextWakeUpTimestamp)
                .utc()
                .format('HH:mm DD MMM')}
            </span>
          </div>
          {!!nextOrderDate.currentMultiOrderIndex && (
            <div className="detail-info-row">
              <span className="detail-info-label">Index:</span>
              <span className="detail-info-value">
                {nextOrderDate.currentMultiOrderIndex} /{' '}
                {nextOrderDate.multiOrderAmount}
              </span>
            </div>
          )}
          {!!nextOrderDate.currentCbr && (
            <div className="detail-info-row">
              <span className="detail-info-label">Current cbr:</span>
              <span className="detail-info-value">
                {nextOrderDate.currentCbr.toFixed(4)}
              </span>
            </div>
          )}
        </>
      )}

      {!!bot.complexParams && (
        <>
          <div className="detail-info-row">
            <span className="detail-info-subtitle">Complex Params:</span>
          </div>

          <div className="detail-info-row">
            <span className="detail-info-label">Cbrt:</span>
            <span className="detail-info-value">{bot.complexParams.cbrt}</span>
          </div>
          <div className="detail-info-row">
            <span className="detail-info-label">ShorterT Candle Interval:</span>
            <span className="detail-info-value">
              {bot.complexParams.shorterTimeFrameInterval}
            </span>
          </div>
          <div className="detail-info-row">
            <span className="detail-info-label">Multi Order Slippage:</span>
            <span className="detail-info-value">
              {bot.complexParams.maxOrderSlippage}
            </span>
          </div>
          <div className="detail-info-row">
            <span className="detail-info-label">Multi Order amount:</span>
            <span className="detail-info-value">
              {bot.complexParams.maxMultiOrderAmount}
            </span>
          </div>
          <div className="detail-info-row">
            <span className="detail-info-label">Start Balance:</span>
            <span className="detail-info-value">
              {formatBalance(bot.complexParams.startBalance)}
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default Info;
